import React from 'react';

function ApiFailure(props) {
  const message = Object.keys(props).includes('message')
    ? props.message
    : 'No data available';
  return (
    <div className='apiFailure'>
      <p className='message'>{message}</p>
    </div>
  );
}

export default ApiFailure;
